import type { MenuEntry } from "../DropdownMenu/DropdownMenu";
import type { RowAction } from "./RowActions";

/** The actions shown as icon buttons in the row and the ones that go into the overflow menu. */
export interface RowActionGroups {
  inline: RowAction[];
  menu: MenuEntry[];
}

/** An action is shown inline only when it asks for it and has an icon to show. */
function isInline(action: RowAction): boolean {
  return Boolean(action.inline && action.icon);
}

function toMenuEntry(action: RowAction): MenuEntry {
  return { label: action.label, icon: action.icon, onSelect: action.onSelect, disabled: action.disabled };
}

function toDangerMenuEntry(action: RowAction): MenuEntry {
  return { label: action.label, icon: action.icon, onSelect: action.onSelect, disabled: action.disabled, tone: "danger" };
}

/** Overflow menu entries: normal actions first, then the dangerous ones after a separator. */
export function menuEntries(actions: RowAction[]): MenuEntry[] {
  const normal = actions.filter((a) => a.tone !== "danger");
  const danger = actions.filter((a) => a.tone === "danger");
  const separator: MenuEntry[] = normal.length && danger.length ? ["separator"] : [];
  return [...normal.map(toMenuEntry), ...separator, ...danger.map(toDangerMenuEntry)];
}

/** Splits the visible actions between inline icon buttons and the overflow menu. */
export function groupRowActions(actions: RowAction[]): RowActionGroups {
  const visible = actions.filter((a) => !a.hidden);
  return {
    inline: visible.filter(isInline),
    menu: menuEntries(visible.filter((a) => !isInline(a))),
  };
}
